/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratOnepager,
    JsonStratOnepagerFromJSON,
    JsonStratOnepagerFromJSONTyped,
    JsonStratOnepagerToJSON,
} from './JsonStratOnepager';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratOnepager
 */
export interface ApiResultOfJsonStratOnepager {
    /**
     * 
     * @type {JsonStratOnepager}
     * @memberof ApiResultOfJsonStratOnepager
     */
    data?: JsonStratOnepager;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepager
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratOnepager
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepager
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratOnepager
     */
    result?: ApiResultOfJsonStratOnepagerResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratOnepagerResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratOnepagerFromJSON(json: any): ApiResultOfJsonStratOnepager {
    return ApiResultOfJsonStratOnepagerFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratOnepagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratOnepager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratOnepagerFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratOnepagerToJSON(value?: ApiResultOfJsonStratOnepager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratOnepagerToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

